import { useEffect } from 'react';
import { useBotContext } from '../components/useBotContext';
import { applyAccessDoorMounting, bot_tunnel_configuration_ids } from '../helpers/data/bot';
import { IBotData, IBotSection } from '../models';

export const useAccessDoorAccessory = (
  tunnelIndex: number,
  sectionIndex: number,
  section?: IBotSection,
) => {
  const { value: botData, setValue } = useBotContext();

  useEffect(() => {
    if (!section) return;

    setValue((draft: IBotData) => {
      const tunnel = draft.tunnels[tunnelIndex];
      const target = tunnel?.sections[sectionIndex];
      if (!target) return;

      target.accessories ||= [];
      const accessDoorIndex = target.accessories.findIndex(
        (acc) => acc.type === 'access_door',
      );

      // Check if section type matches conditions for access door
      const needsAccessDoor =
        target.type === 'fan' ||
        target.type === 'plenum' ||
        (target.type === 'coil' && target.duty_id === 1);

      if (needsAccessDoor) {
        const tunnelConfigId = botData.tunnel_configuration as
          | 1
          | 2
          | 3
          | 4
          | 5;

        // Auto-create access_door if it doesn't exist
        if (accessDoorIndex === -1) {
          target.accessories.push({
            type: 'access_door',
            name: 'Access Door',
            mounting_plane_id: applyAccessDoorMounting(
              tunnel.airflow_direction_id,
              bot_tunnel_configuration_ids[tunnelConfigId],
              tunnelIndex,
            ),
          });
        } else {
          target.accessories[accessDoorIndex].mounting_plane_id =
            applyAccessDoorMounting(
              tunnel.airflow_direction_id,
              bot_tunnel_configuration_ids[tunnelConfigId],
              tunnelIndex,
            );
        }
      } else {
        // Remove access_door if section no longer meets criteria
        if (accessDoorIndex !== -1) {
          target.accessories.splice(accessDoorIndex, 1);
        }
      }
    });
  }, [
    tunnelIndex,
    sectionIndex,
    section?.type,
    section?.duty_id,
    setValue,
    botData.tunnels[tunnelIndex].airflow_direction_id,
  ]);
};
